"use strict";
/**
 * Location checks for clocking in and out.
 *
 * The threshold answers one question: was the person at the branch? In October 2026, under a
 * 500 m block, 26% of clock-ins were clicked at 250-500 m against 1% of clock-outs from the same
 * phones, and at Urban the avenue is only 100-130 m from the store. Same limit for all branches.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CLOCK_IN_MAX_DISTANCE_METERS = void 0;
exports.calculateDistanceMeters = calculateDistanceMeters;
exports.isUsableGeoPoint = isUsableGeoPoint;
exports.evaluateClockLocation = evaluateClockLocation;
/** A clock-in farther than this from the branch is blocked */
exports.CLOCK_IN_MAX_DISTANCE_METERS = 100;
/** Great-circle distance in meters (haversine) */
function calculateDistanceMeters(a, b) {
    const R = 6371000;
    const toRad = (deg) => (deg * Math.PI) / 180;
    const dLat = toRad(b.latitude - a.latitude);
    const dLon = toRad(b.longitude - a.longitude);
    const h = Math.sin(dLat / 2) ** 2 +
        Math.cos(toRad(a.latitude)) * Math.cos(toRad(b.latitude)) * Math.sin(dLon / 2) ** 2;
    return 2 * R * Math.atan2(Math.sqrt(h), Math.sqrt(1 - h));
}
/** A point is usable when it has finite coordinates and is not the 0,0 placeholder */
function isUsableGeoPoint(point) {
    return (!!point &&
        Number.isFinite(point.latitude) &&
        Number.isFinite(point.longitude) &&
        !(point.latitude === 0 && point.longitude === 0));
}
/** Distance from where the person clocks to the branch, and whether it counts as far */
function evaluateClockLocation(position, branch) {
    if (!isUsableGeoPoint(position) || !isUsableGeoPoint(branch)) {
        return { distanceMeters: null, status: 'unknown' };
    }
    const distanceMeters = Math.round(calculateDistanceMeters(position, branch));
    return {
        distanceMeters,
        status: distanceMeters <= exports.CLOCK_IN_MAX_DISTANCE_METERS ? 'ok' : 'far',
    };
}
